import './styles/App.css';
import * as React from "react";
import {BrowserRouter as Router, Routes, Route, Link} from "react-router-dom";
import {MainMenu} from "./components/Menu";
import {HeroSection} from "./components/HeroSection";
import {HowItWorks} from "./components/HowItWorks";
import {WhatWeDo} from "./components/WhatWeDo";
import {Pricing} from "./components/Pricing";
import {Testimonials} from "./components/Testimonials";
import {Faq} from "./components/Faq";
import {Footer} from "./components/Footer";
import {Templates} from "./components/Templates";
import {WorkThatWorks} from "./components/WorkThatWorks";
import BookingWidget from "./components/BookingWidget";
import moment from "moment/moment";
import {useEffect} from "react";
import {Config} from "./Config";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import CookieBar from './components/CookieBar';
import Page404 from "./components/404";

let bookingLoaderInterval = null;
function App() {
    //const location = useLocation();
    const [bookedTimes, setBookedTimes] = React.useState({});
    console.log(window.location.pathname);
    const isHome = window.location.pathname === "/";

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const section = entry.target;
                    const elements = section.querySelectorAll('.animate-from-bottom');
                    elements.forEach(el => el.classList.add('in-view'));
                    // Optional: stop observing after triggered once
                    observer.unobserve(section);
                }
            });
        }, {
            threshold: 0.3 // Trigger when 30% of section is visible
        });

        document.querySelectorAll('.section').forEach(section => {
            observer.observe(section);
        });
    })

    useEffect(() => {
        loadBookingData();
        bookingLoaderInterval = setInterval(loadBookingData, 60 * 1000)
        return () => {
            clearInterval(bookingLoaderInterval);
        }
    }, []);

    async function loadBookingData() {
        try {
            const data = await fetch(process.env.PUBLIC_URL + "/assets/booking");
            if(data) {
                const parsed = await data.json();
                if(parsed) {
                    setBookedTimes(parsed);
                }
            }
        } catch (e) {

        }
    }

    async function onBookingSubmit(info : {
        date: string;
        time: string;
        name: string;
        email: string;
        note: string;
        source?: string;
    }) {
        let formData = new FormData();
        formData.append('date', info.date);
        formData.append('time', info.time);
        formData.append('name', info.name);
        formData.append('email', info.email);
        formData.append('note', info.note);
        info.source && formData.append('source', info.source);

        try {
            let response = await fetch(Config.BookingRequestUrl, {
                method  : "POST",
                body    : formData
            });
            let result = await response.json();

            if (result.result === "SUCCESSFUL") {
                return true;
            } else {
                console.error(result.message);
                return false;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    function generateAvailableDaysForCurrentMonth() {
        const result : string[] = [];
        let endOfMonth;
        if (moment().date() > 25) {
            endOfMonth = moment().add(1, "month").endOf("month");
        } else {
            endOfMonth = moment().endOf("month");
        }

        // starts from tomorrow
        let day = moment().add(1, "days");

        while (day.isSameOrBefore(endOfMonth, "day")) {
            const weekday = day.isoWeekday(); // 1 = Monday, 7 = Sunday
            if (weekday >= 1 && weekday <= 5) {
                const dateStr = day.format("YYYY-MM-DD");

                result.push(dateStr);
            }

            day.add(1, "day");
        }

        return result;
    }
    function generateAvailableTimesForCurrentMonth(): Record<string, string[]> {
        const result: Record<string, string[]> = {};
        const startOfMonth = moment().startOf("month");
        let endOfMonth;
        if (moment().date() > 25) {
            endOfMonth = moment().add(1, "month").endOf("month");
        } else {
            endOfMonth = moment().endOf("month");
        }

        let day = startOfMonth.clone();

        while (day.isSameOrBefore(endOfMonth, "day")) {
            const weekday = day.isoWeekday(); // 1 = Monday, 7 = Sunday
            if (weekday >= 1 && weekday <= 5) {
                const dateStr = day.format("YYYY-MM-DD");
                const slots: string[] = [];

                const startTime = day.clone().hour(9).minute(0);
                const endTime = day.clone().hour(16).minute(30);

                while (startTime.isBefore(endTime)) {
                    slots.push(startTime.format("HH:mm"));
                    startTime.add(30, "minutes");
                }

                result[dateStr] = slots;
            }

            day.add(1, "day");
        }

        return result;
    }

    function renderMainPage() {
        return <main className="App">
            <MainMenu isHome={isHome} />
            <HeroSection />
            <WhatWeDo />
            <HowItWorks />
            <Testimonials />
            <Pricing />
            <Templates />
            <WorkThatWorks />
            <Faq />
            <BookingWidget availableTimes={generateAvailableTimesForCurrentMonth()}
                           availableDays={generateAvailableDaysForCurrentMonth()}
                           fullyBookedTimes={bookedTimes}
                           onSubmit={onBookingSubmit}
            />
            <Footer isHome={isHome} />
        </main>
    }

    function renderPrivacyPolicy() {
        return <main className="App">
            <MainMenu isHome={isHome} />
            <PrivacyPolicy />
            <Footer isHome={isHome} />
        </main>
    }

    function termsAndConditions() {
        return <main className="App">
            <MainMenu isHome={isHome} />
            <TermsAndConditions />
            <Footer isHome={isHome} />
        </main>
    }

    return (
        <Router basename={process.env.PUBLIC_URL}>
            <CookieBar />
            <Routes>
                <Route path="/" element={renderMainPage()} />
                <Route path={"/" + Config.PageLinks.PrivacyPolicy} element={renderPrivacyPolicy()} />
                <Route path={"/" + Config.PageLinks.TermsAndConditions} element={termsAndConditions()} />
                <Route path="*" element={<Page404 />}/>
            </Routes>
        </Router>
    );
}

export default App;
